/**
 * Единые константы приложения-тренажёра.
 */

// Переменные, которые хранятся как скаляр, а не как массив значений по фразам.
// conflictType — свойство всего конфликта (один на все фразы); prevStep — этап ПРОШЛОЙ
// фразы, захватывается при переходе. Оба скаляры, а не массивы по фразам.
export const NON_ARRAY_VARIABLES = ['situation', 'currentPhraseIndex', 'viewingPhraseIndex', 'conflictType', 'prevStep'];

// Ключи localStorage. Сохраняем прежние имена — чтобы не терять прогресс пользователей.
export const STORAGE_KEYS = {
  state: 'conflict_app_state',
  history: 'conflict_app_history',
  variables: 'conflict_app_variables',
};

// Спец-цель перехода (nextId / mapping): показать экран итогов.
export const SUMMARY_TARGET = 'summary';

// Начальные значения переменных.
export const INITIAL_VARIABLES = { currentPhraseIndex: 0, viewingPhraseIndex: 0 };
